import * as React from "react";

import { useWorkspaceLoaderData } from "../../loader";
import { useWorkspaceSidebar } from "../../sidebarContext";
import { SidebarTab, SidebarViewType } from "../../sidebarContext/sidebarView";

/**
 * Opens the sidebar view the loader chose for the `?event=` link: the event's
 * details when the event loaded, or the events list when it could not (so a
 * missing or forbidden event leaves the user browsing events rather than
 * stuck on a broken detail view).
 *
 * The view opens once and re-opens only when the loader's choice changes, so
 * closing the sidebar afterwards leaves it closed.
 */
export function useEventDeepLink() {
  const { eventSidebar } = useWorkspaceLoaderData();
  const { openView, setActiveTab } = useWorkspaceSidebar();

  const eventId = eventSidebar?.eventId;
  const view = eventSidebar?.view;

  React.useEffect(() => {
    if (view === "details" && eventId) {
      openView({
        type: SidebarViewType.EventDetails,
        data: { eventId },
      });
      return;
    }

    if (view === "events-list") {
      openView({ type: SidebarViewType.TabbedSidebar, data: undefined });
      setActiveTab(SidebarTab.Events);
    }
  }, [eventId, view, openView, setActiveTab]);
}
